// extracted by mini-css-extract-plugin
export var container = "blogs-module--container--3nyJ9";
export var link = "blogs-module--link--2vkT8";
export var image = "blogs-module--image--15TCn";